import React, { useState, useEffect } from "react";
import { connect, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import {
  Grid,
  Typography,
  Button,
  TextField,
  makeStyles,
} from "@material-ui/core";
import { useNavigate } from "react-router-dom";
import DialogTitle from "@mui/material/DialogTitle";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import useMediaQuery from "@mui/material/useMediaQuery";
import OtpInput from "react-otp-input";
import CloseIcon from "@mui/icons-material/Close";
import {
  get_customer_list,
  save_customer_list,
  customer_registration,
} from "../../utils/customer_helper";
import { set_customer, set_last_order, customer_membership } from "../../store/actions/action";
import { BUTTON_COLOR, TEXT_COLOR } from "../../utils/constant";

const useStyles = makeStyles(() => ({
  main_sectiondiv1: {
    height: "20vh",
  },

  main_button: {
    width: "90%",
    padding: "1rem",
    borderRadius: "1rem",
    fontSize: "1.2rem",
    textTransform: "capitalize",
  },
}));

const LoginPopup = function (props) {
  const { reducer } = props;

  const location = useLocation();
  const data1 = location.state;

  const { customer } = reducer;
  const storeInfo = props.sessionReducer?.store_details;
  const storeInfoConfig = props.sessionReducer?.store_config;
  const navigate = useNavigate();
  const classes = useStyles();
  const [formValues, setFormValues] = useState({});
  const [errormsg, setErrormsg] = useState(false);
  const [phoneNumbermsg, setPhoneNumbermsg] = useState(false);
  const [verificationnumber, setVerificationnumber] = useState("");
  const [gotVerificationNumber, setGotVerificationNumber] = useState(false);
  const [namefield, setNamefield] = useState(false);
  const [namefieldmsg, setNamefieldmsg] = useState(false);
  const [addressfieldmsg, setAddressfieldmsg] = useState(false);
  const [customerData, setCustomerData] = useState("");
  const [custMoile, setCustMoile] = useState("");
  const [saveCustomer, setSaveCustomer] = useState(false);
  const [preOrder, setPreOrder] = useState({});
  const [customerRegistration, setCustomerRegistration] = useState(false);
  const [minutes, setMinutes] = useState(1);
  const [seconds, setSeconds] = useState(30);
  const [verificationError, setVerificationError] = useState(false);
  const [emptyVerification, setEmptyVerification] = useState(false);

  const isDesktop = useMediaQuery("(min-width: 900px)");
  let menuStore = storeInfoConfig?.web_ordering_setting?.is_menu;
  let skipOtp = storeInfoConfig?.web_ordering_setting?.skip_otp_qr;

  const sessionReducer = useSelector(state => state.sessionReducer) || {};
  const reduxConfig = sessionReducer.store_config || storeInfoConfig || props.sessionReducer?.store_config || {};
  let primaryColor =  reduxConfig?.general_config?.primary_color;
  let secondaryColor =  reduxConfig?.general_config?.secondary_color;


  const orderType = useSelector(state => state.cartReducer?.orderType);
  let type = orderType?.order?.order_type;


  const handleClearField = () => {
    setFormValues({ ...formValues, cust_first_name: "" }); // Clear the value of the text field
  };
  const lineStyle = {
    flex: 1,
    height: "1px",
    borderTop: "1px solid black",
    margin: "0 5px",
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormValues({ ...formValues, [name]: value });
  };

  const resendOTP = () => {
    setMinutes(1);
    setSeconds(0);
    postOTP();
  };

  const SaveUserInfo = async () => {
    // Validate phone number
    if (custMoile?.length !== 10) {
      setPhoneNumbermsg(true);
      return;
    }

    // Validate name
    if (!formValues?.cust_first_name) {
      setNamefieldmsg(true);
      return;
    }
    
    const hasCustomerDetails = customerData?.customer_details?.length > 0;

    // Handle case when no customer details are present and customer is not yet saved
    if (!hasCustomerDetails && !saveCustomer) {
      if (skipOtp) {
        saveCustomerAPi();
      } else {
        setSaveCustomer(true);
      }
    }

    // Handle case when customer details exist
    else if (hasCustomerDetails) {
      if (skipOtp) {
        saveCustomerAPi();
      } else {
        setCustomerRegistration(true);
        postOTP();
      }
    }
  };

  const saveCustomerAPi = async () => {
    const resp = await save_customer_list({
      ...formValues,
      cust_mobile: custMoile,
    });
    props.set_customer({ ...formValues });
    props?.set_last_order(preOrder);
    if (resp) {
      setSaveCustomer(false);
      let membership = null;
      const sourceObj = preOrder || resp;
      if (sourceObj?.membership) {
        membership = sourceObj.membership;
      } else if (sourceObj?.customer_details?.[0]?.customer_membership) {
        membership = sourceObj.customer_details[0].customer_membership;
      } else if (sourceObj?.order_details?.length) {
        const orderWithMem = sourceObj.order_details.find(o => o.customer_details?.[0]?.customer_membership);
        if (orderWithMem) membership = orderWithMem.customer_details[0].customer_membership;
      }
      if (membership && props.customer_membership) {
        props.customer_membership([membership]);
      }
      props?.set_customer({ ...formValues, ...resp });
      // setOpenUserInfo(false);
      setPhoneNumbermsg("");
      setNamefield("");
      navigate(
        menuStore ? (isDesktop ? "/menu" : "/menu-items") : data1?.navigateTo ? "/cart" : "/customer"
      );
    }
  };

  const RegisterCustomer = async () => {
    if (parseInt(verificationnumber) === parseInt(gotVerificationNumber)) {
      setVerificationError(false);
      saveCustomerAPi();
    } else {
      if (verificationnumber.trim().length < 6) {
        setEmptyVerification(true);
        setVerificationError(false);
      } else {
        setVerificationError(true);
        setEmptyVerification(false);
      }
      // setErrormsg("Verification nmumber is incorrect");
    }
  };

  // const postData = async () => {
  //   try {
  //     const resp = await save_customer_list({
  //       ...formValues,
  //       cust_mobile: custMoile,
  //     });
  //     if (resp) {
  //       setSaveCustomer(false);
  //       props?.set_customer({ ...formValues, ...resp });
  //       navigate(!customer ? "/cart" : "/customer");
  //     }
  //   } catch (error) {
  //     console.error("Error fetching customer data:", error);
  //   }
  // };
  const handleClick = () => {
    navigate("/menu");
  };
  const postOTP = async () => {
    try {
      setMinutes(1);
      setSeconds(0);
      const otp = await customer_registration({
        to_phone_number: custMoile,
      });
      // console.log("got otp", otp);
      setGotVerificationNumber(otp);
      setCustomerRegistration(true);
      setErrormsg(true);
      setSaveCustomer(false);
    } catch (error) {
      console.error("Error fetching customer data:", error);
    }
  };

  useEffect(() => {
    let interval = null;
    if (minutes > 0 || seconds > 0) {
      interval = setInterval(() => {
        if (seconds > 0) {
          setSeconds((prevSeconds) => prevSeconds - 1);
        } else if (minutes > 0) {
          setMinutes((prevMinutes) => prevMinutes - 1);
          setSeconds(59);
        }
      }, 1000);
    }
    return () => {
      if (interval) clearInterval(interval);
    };
  }, [minutes, seconds]);

  useEffect(() => {
    if (saveCustomer) {
      postOTP();
    }
  }, [saveCustomer]);

  const fetchData = async () => {
    try {
      const resp = await get_customer_list({ cust_mobile: custMoile });
      setCustomerData(resp);
      setNamefield(true);
      setErrormsg(false);
      let customer = {};
      if (resp?.customer_details?.length) {
        customer = resp;
        setFormValues({ ...formValues, ...customer.customer_details[0] });
        setPhoneNumbermsg(false);
        setPreOrder({ ...customer });
      } else {
        setErrormsg(true);
        setFormValues("");
      }
    } catch (error) {
      console.error("Error fetching customer data:", error);
    }
  };

  useEffect(() => {
    if (custMoile?.length === 10) {
      fetchData();
    }
  }, [custMoile]);

  return (
    <>
      {!customerRegistration && (
        <Grid>
          <Grid
            style={{
              margin: "40px 0px 0px 30px",
              display: "flex",
              justifyContent: "flex-start",
            }}
            onClick={handleClick}
          >
            {/* <ArrowBackIosIcon /> */}
          </Grid>

          <Grid
            style={{
              paddingBottom: "2rem",
              textAlign: "center",
              marginTop: "30%",
              overflow: "hidden",
            }}
          >
            <Typography>
              <span
                style={{
                  fontFamily: "Satoshi",
                  fontWeight: "500",
                  fontSize: "22px",
                  padding: "0rem 1rem",
                  lineHeight: "36px",
                }}
              >
                <b>Sign In with Phone Number</b>
              </span>
            </Typography>
          </Grid>
          <Grid style={{ padding: "0% 15%", textAlign: "center" }}>
            <Typography>
              <span
                style={{
                  fontFamily: "Satoshi",
                  fontWeight: "500",
                  fontSize: "16px",
                  lineHeight: "1",
                }}
              >
                {storeInfoConfig?.web_ordering_setting?.customer_screen_subline ||
                  (skipOtp
                    ? "Enter your phone no. to proceed."
                    : "We will send an OTP to your phone for signing in")}
              </span>
            </Typography>
          </Grid>
          <Grid
            container
            xs={12}
            sm={12}
            md={12}
            lg={12}
            style={{ padding: "1rem", flexDirection: "column" }}
            justifyContent="center"
          >
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                position: "relative",
              }}
            >
              <TextField
                className="bold-placeholder"
                style={{
                  width: "65%",
                  padding: "0.5rem 3rem 0.5rem 0.5rem",
                  border: "1px solid black",
                  borderRadius: "10px",
                }}
                onWheel={(e) => e.target.blur()}
                InputProps={{
                  disableUnderline: true,
                }}
                name="cust_mobile"
                type="number"
                onInput={(e) => {
                  e.target.value = Math.max(0, parseInt(e.target.value))
                    .toString()
                    .slice(0, 10);
                }}
                onChange={(e) => {
                  setCustMoile(e.target.value);
                  if (e.target.value?.length < 11) {
                    setFormValues({ ...formValues, cust_first_name: "" });
                  }
                }}
                value={custMoile}
                placeholder="Enter phone number"
              />
              {custMoile && (
                <button
                  style={{
                    position: "absolute",
                    top: "72%",
                    right: "13%",
                    transform: "translateY(-90%)",
                    background: "none",
                    border: "none",
                    cursor: "pointer",
                  }}
                  onClick={() => setCustMoile("")}
                >
                  <CloseIcon style={{ color: "black" }} />
                </button>
              )}
            </div>
            <span style={{ color: "red", fontFamily: "Satoshi" }}>
              {errormsg
                ? "User not Found. Please register."
                : phoneNumbermsg
                ? "Phone no. is required"
                : ""}{" "}
            </span>
            {errormsg || namefield ? (
              <> 
              <Grid
                container
                xs={12}
                sm={12}
                md={12}
                lg={12}
                style={{ padding: "1rem 1rem", flexDirection: "column" }}
                justifyContent="center"
              >
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    position: "relative",
                  }}
                >
                  <TextField
                    className="bold-placeholder"
                    style={{
                      width: "70%",
                      padding: "0.5rem 3rem 0.5rem 0.5rem",
                      border: "1px solid black",
                      borderRadius: "10px",
                    }}
                    InputProps={{
                      disableUnderline: true,
                    }}
                    name="cust_first_name"
                    onChange={handleChange}
                    onWheel={(e) => e.target.blur()}
                    value={formValues?.cust_first_name}
                    placeholder="Enter your name"
                  />
                  {formValues?.cust_first_name && (
                    <button
                      style={{
                        position: "absolute",
                        top: "72%",
                        right: "10%",
                        transform: "translateY(-90%)",
                        background: "none",
                        border: "none",
                        cursor: "pointer",
                      }}
                      onClick={handleClearField}
                    >
                      <CloseIcon />
                    </button>
                  )}
                </div>
                <span style={{ color: "red", fontFamily: "Satoshi" }}>
                  {namefieldmsg ? "Name is required" : ""}{" "}
                </span>
              </Grid>
               </>  ) : null}
          </Grid>
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              left: 0,
              right: 0,
              bottom: 10,
              marginBottom: "2rem",
            }}
          >
            {!customer && <></>}

            <Grid
              style={{
                width: "70%",
                display: "flex",
                flexDirection: "column",
              }}
            >
              <Button
                fullWidth
                variant="contained"
                style={{
                  fontSize: "1rem",
                  borderRadius: "10px",
                  padding: "10px 0px",
                  maxWidth: "500px",
                  // border: "1px solid black",
                  color:  "white"  || TEXT_COLOR,
                  background:primaryColor || BUTTON_COLOR,
                  display: "flex",
                  justifyContent: "center",
                }}
                onClick={SaveUserInfo}
              >
                {errormsg ? "Sign Up" : "Next"}
              </Button>
            </Grid>
          </div>
        </Grid>
      )}
      {customerRegistration && (
        <Grid
          style={{
            minHeight: "100vh",
          }}
        >
          <DialogTitle
            style={{
              fontWeight: "bold",
            }}
          >
            <Typography
              style={{
                textAlign: "center",
                marginTop: "20vh",
                fontWeight: "bold",
              }}
              variant="h4"
            >
              {customerRegistration
                ? "Verify OTP"
                : errormsg
                ? "Sign Up"
                : "Sign In"}
            </Typography>
          </DialogTitle>

          <Grid
            container
            xs={12}
            sm={12}
            md={12}
            lg={12}
            style={{ padding: "2rem", paddingTop: "0rem" }}
          >
            <Grid container xs={12} sm={12} md={12} lg={12}>
              <Grid
                style={{
                  paddingLeft: "0.5rem",
                  display: "flex",
                  justifyContent: "center",
                  flexDirection: "column",
                }}
                item
                xs={12}
                sm={12}
                md={12}
                lg={12}
              >
                <Typography
                  style={{
                    fontWeight: "bold",
                    paddingBottom: "1rem",
                    textAlign: "center",
                    marginBottom: "2rem",
                  }}
                >
                  +91-{custMoile}
                </Typography>
                <Typography
                  style={{
                    // fontWeight: "bold",
                    paddingBottom: "1rem",
                    textAlign: "center",
                  }}
                >
                  Enter the otp in the box below to continue
                </Typography>
              </Grid>
              <Grid
                style={{
                  paddingLeft: "0.5rem",
                  display: "flex",
                  justifyContent: "center",
                }}
                item
                xs={12}
                sm={12}
                md={12}
                lg={12}
              >
                <OtpInput
                  inputStyle={{
                    height: "2.6rem",
                    width: "2rem",
                    // marginTop: "3rem",
                    border: "1px solid grey",
                    borderRadius: "0.6rem",
                    padding: "0.2rem 0.4rem",
                  }}
                  value={verificationnumber}
                  name="verification_number"
                  onChange={setVerificationnumber}
                  inputType="tel"
                  numInputs={6}
                  renderSeparator={
                    <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
                  }
                  renderInput={(props) => <input {...props} className="no-spinners" />}
                />
              </Grid>
              <Grid
                style={{
                  paddingLeft: "0.5rem",
                  display: "flex",
                  justifyContent: "center",
                }}
                item
                xs={12}
                sm={12}
                md={12}
                lg={12}
              >
                <Typography
                  style={{
                    color: "red",
                    fontWeight: "bold",
                    fontSize: "0.8rem",
                    paddingTop: "0.2rem",
                  }}
                >
                  {verificationError && "Verification code is incorrect"}
                  {emptyVerification && "Enter Complete Verification code"}
                </Typography>
              </Grid>
              <Grid
                container
                xs={12}
                sm={12}
                md={12}
                lg={12}
                style={{
                  display: "flex",
                  justifyContent: "center",
                }}
              >
                <Grid
                  item
                  xs={12}
                  sm={12}
                  md={6}
                  lg={6}
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    fontFamily: "Satoshi",
                    marginTop: "2rem",
                  }}
                >
                  {seconds > 0 || minutes > 0 ? (
                    <p>
                      Time Remaining: {minutes < 10 ? `0${minutes}` : minutes}:
                      {seconds < 10 ? `0${seconds}` : seconds}
                    </p>
                  ) : (
                    <h6>
                      Didn't recieve code?{" "}
                      <span
                        disabled={seconds > 0 || minutes > 0}
                        style={{
                          color:
                            seconds > 0 || minutes > 0 ? "#DFE3E8" : "#FF5630",
                        }}
                        onClick={resendOTP}
                      >
                        {" "}
                        Resend OTP
                      </span>
                    </h6>
                  )}
                </Grid>
                <Grid
                  item
                  xs={4}
                  sm={4}
                  md={6}
                  lg={6}
                  style={{ display: "flex", justifyContent: "center" }}
                >
                  {/* <Button
                      disabled={seconds > 0 || minutes > 0}
                      style={{
                        color:
                          seconds > 0 || minutes > 0 ? "#DFE3E8" : "#FF5630",
                      }}
                      onClick={resendOTP}
                    >
                      Resend OTP
                    </Button> */}
                </Grid>
              </Grid>
              {/* </div> */}
              <Grid
                // className="PaymentBtn"
                item
                xs={12}
                sm={12}
                md={12}
                lg={12}
                style={{ display: "flex", justifyContent: "center" }}
              >
                <Button
                  style={{
                    fontSize: "1rem",
                    borderRadius: "10px",
                    minWidth: "70%",

                    color:  "white"  || TEXT_COLOR,
                    background:primaryColor || BUTTON_COLOR,
                  }}
                  variant="contained"
                  onClick={RegisterCustomer}
                >
                  Verify
                </Button>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      )}
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    cartProps: state.cartReducer,
    reducer: state.customerReducer,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    set_customer: (obj) => {
      dispatch(set_customer(obj));
    },
    set_last_order: (obj) => {
      dispatch(set_last_order(obj));
    },
    customer_membership: (obj) => {
      dispatch(customer_membership(obj));
    },
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(LoginPopup);
